<style lang="less" scoped>
  .member-info-cover {
    margin-bottom: 34px;
  }
  .member-info-row {
    margin-bottom: 15px;
    display: flex;
    align-content: items;
    > strong {
      margin-right: 5px;
      display: flex;
      align-items: center;
      min-width: 80px;
    }
  }
  .member-photo-cover {
    width: 100%;
    max-width: 600px;
  }
  .member-photo-row {
    display: flex;
  }
  .member-photo-col {
    width: 50%;
    padding-right: 20px;
  }
  .member-photo-title {
    margin-bottom: 10px;
    font-weight: bold;
  }
  .member-photo {
    width: 100%;
    min-height: 250px;
    background-repeat: no-repeat;
    background-size: cover;

    > img {
      display: block;
      width: 100%;
    }
  }
  .member-photo-caption {
    padding-top: 15px;
  }
</style>

<template lang="pug">
  #order.admin-container(v-if="member", v-loading="isLoading")
    .admin-title-cover
      .admin-title {{ member.name }} - {{ member.email }}
    .admin-content-cover
      .member-info-cover
        .member-info-row
          strong 승인 상태
          span
            el-switch(
              :value="member.isAccepted",
              @change="changeAccepted")
        .member-info-row
          strong 유형
          span {{ displayType }}
        .member-info-row
          strong 전화번호
          span {{ member.phoneNumber }}
      .member-photo-cover
        .member-photo-row(v-if='member.type === "doctor"')
          .member-photo-col
            .member-photo-title 사업자 등록증
            .member-photo(
              :style="{ backgroundImage: `url(${member.businessRegistration})` }",
              @click="viewDetailPhoto(member.businessRegistration)")
          .member-photo-col
            .member-photo-title 한의사 면허증
            .member-photo(
              :style="{ backgroundImage: `url(${member.doctorLicense})` }",
              @click="viewDetailPhoto(member.doctorLicense)")
        .member-photo-row(v-if='member.type === "student"')
          .member-photo-col
            .member-photo-title 학생증
            .member-photo(
              :style="{ backgroundImage: `url(${member.studentIDCard})` }",
              @click="viewDetailPhoto(member.businessRegistration)")
        .member-photo-caption
          div 클릭하여 확대가능
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      memberId: state => state.route.params.memberId,
    }),
    displayType() {
      if (!this.member) return null;
      if (this.member.type === 'doctor') return '사업자';
      return '학생';
    },
  },
  data() {
    return {
      member: null,
      isLoading: false,
    };
  },
  async mounted() {
    this.isLoading = true;
    const { data } = await this.$http.get(`/users/${this.memberId}`);
    this.member = data;
    this.isLoading = false;
  },
  methods: {
    async changeAccepted(value) {
      await this.$http.put(
        `/users/${this.memberId}`,
        { isAccepted: value },
      );
      this.member.isAccepted = value;
    },
    viewDetailPhoto(src) {
      window.location.href = src;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/member_detail.vue